<template lang="pug">
  .component-refundable-records
    ModalReveal(:ref="componentId")
      button.button.danger(slot="trigger") Select records
      .header(slot="header")
        h2 Select records to refund
        .row
          .column.large-6
            label Invoice final sectional / Internal id
              input(type="text", v-model="search.invoice_id")
      .row.column
        base-list#refundable-list(:component="component", :dataLoader="dataLoader", v-model="selected", :search="search" :resultsPerPage="5", :selectableList="true")
      button.button(slot="footer", @click="close" ) Add records
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Close
</template>
<script type="text/babel">
import ModalReveal from '../../../foundation/ModalReveal'
import InputSwitch from '../../InputSwitch'
import ActionButton from '../../ActionButton'
import VatAmountToggler from '../../../../backoffice/VatAmountToggler'
import BaseList from "../../../../../pages/backoffice/BaseList.vue";

export default {
  name: 'RefundableRecords',
  components: {BaseList, VatAmountToggler, ActionButton, InputSwitch, ModalReveal},
  data() {
    return {
      component: require('src/components/backoffice/WalletRecord.vue'),
      refundable: {},
      search: {wallet_record_id: null, invoice_id: null}
    }
  },
  created() {

  },
  methods: {
    convertArrayToObject(array, key) {
      const initialValue = {};
      return array.reduce((obj, item) => {
        return {
          ...obj,
          [item[key]]: item,
        };
      }, initialValue);
    },
    close() {
      this.$emit('select', this.selected)
      this.$refs[this.componentId].close()
    },
  },
  computed: {
    componentId() {
      return `refundableRecords-${this._uid}`
    }
  },
  props: ['dataLoader', 'selected'],
}
</script>
<style lang="sass" rel="stylesheet/sass">
#global-modal-container
  #refundable-list
    .flex-list
      input[type=checkbox]
        margin-right: 2em !important

.component-refundable-records


  .modal-footer
    .footer
      display: flex
      justify-content: space-around
</style>



// WEBPACK FOOTER //
// RefundableWalletRecords.vue?c7c0b1f8